module.exports = __webpack_public_path__ + "assets/img/left-64ce1731.png";